import { useEffect } from "react";
import PropTypes from "prop-types";

// Legacy appointment fields use flat resource options instead of requirement groups.
const AppointmentSingleResourceSelection = ({ formik, options, fieldName = "" }) => {
  const selectedValues = fieldName
    ? fieldName.split(".").reduce((value, key) => value?.[key], formik.values)
    : formik.values;
  const selectedId = selectedValues?.resource_item_id;
  const soleId = Array.isArray(options) && options.length === 1
    ? options[0]?.value ?? options[0]?.id
    : null;

  useEffect(() => {
    if (!selectedId && soleId) {
      formik.setFieldValue(`${fieldName ? `${fieldName}.` : ""}resource_item_id`, soleId, true);
    }
  }, [fieldName, formik.setFieldValue, selectedId, soleId]);

  return null;
};

AppointmentSingleResourceSelection.propTypes = {
  formik: PropTypes.shape({ values: PropTypes.object.isRequired, setFieldValue: PropTypes.func.isRequired }).isRequired,
  options: PropTypes.array,
  fieldName: PropTypes.string,
};

export default AppointmentSingleResourceSelection;
